import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import { GlobalProvider } from "./context/globalContext";
import { Spinner } from './styles/globalStyles'

const App = React.lazy(() => import('./pages/App'));

ReactDOM.render(
  <BrowserRouter>
    <GlobalProvider>
    <Suspense fallback={<Spinner />}>
      <App />
    </Suspense>
    </GlobalProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
